import { jwtDecode } from "jwt-decode";

export const decodeChecker = (code) => {
    try {
        return jwtDecode(code);
    } catch (err) {
        return false;
    }
}
